









































































































































































import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { mapState } from 'vuex';

import { objectIsEmpty } from '~/utils/common.js';

import CheckBoxesDropdown from '~/components/partials/CheckBoxesDropdown.vue';
import MapOutline from '~/components/icons/MapOutline.vue';
import ProfileRunsDateFilter from '~/components/partials/ProfileRunsDateFilter.vue';
import CheckInput from '~/components/inputs/CheckInput.vue';
import EventCard from '~/components/cards/EventCard.vue';
import LocalisationEventsMobileModal from '~/components/lists/items/LocalisationEventsMobileModal.vue';
import LabelsDropdown from "~/components/partials/LabelsDropdown.vue";
import SportsDropdown from "~/components/partials/SportsDropdown.vue";

const Modal = {
  MOBILE_EVENTS: 'events',
};

@Component({
  components: {
    SportsDropdown,
    LabelsDropdown,
    CheckBoxesDropdown,
    MapOutline,
    ProfileRunsDateFilter,
    CheckInput,
    EventCard,
    LocalisationEventsMobileModal,
  },
  computed: {
    ...mapState([
      'isMobileDownloadBannerDisplayed',
    ]),
    ...mapState('explorer', [
      'displayLocalisationMap',
      'mobileLocalisationFiltersModal',
      'destinationEventsFilters',
      'eventsList',
      'destinationEvents',
    ]),
    ...mapState('lang', [
      'locale',
    ]),
  },
})
export default class LocalisationEvents extends Vue {
  @Prop({ type: Array, default: () => [] }) value : Array<number | string>;
  @Prop(Array) events: [];
  @Prop(Array) sports: [];
  @Prop(Boolean) isInLocalisationContext: false;

  isMobileDownloadBannerDisplayed : boolean;
  locale: string;
  displayLocalisationMap: boolean;
  mobileLocalisationFiltersModal: string;
  destinationEventsFilters: {[key: string]: any};
  eventsList: Types.EventList;
  destinationEvents: Types.EventList;

  $refs: {
    eventTab: HTMLDivElement,
    container: HTMLDivElement,
  }

  Modal = Modal;
  modal: string = '';

  eventTypes: Array<Types.CheckboxElement> = [
    { checked: false, id: 'COURSE', name: this.$t('localisationEvents.types.course') },
    { checked: false, id: 'RACE', name: this.$t('localisationEvents.types.race') },
    { checked: false, id: 'STAY', name: this.$t('localisationEvents.types.stay') },
    { checked: false, id: 'EVENT', name: this.$t('localisationEvents.types.event') },
  ];

  selectedEvents: Array<Types.CheckboxElement> = [];
  selectedRange: any = {};
  selectPastEvents: boolean = true;
  selectedSports: Array<number> = [];
  selectedLabels: Array<number> = [];

  calculatedDivHeight: number = 300;
  cantDoMore: boolean = false;

  handleInput (newValue: Array<Number | String>) {
    this.$emit('input', newValue);
  }

  emitHasScrolled () {
    const comparator: Types.EventList = this.isInLocalisationContext ? this.destinationEvents : this.eventsList;
    if (this.events.length && (this.events.length !== comparator.total)) {
      this.$emit('load-routes');
    }
  }

  @Emit('search-events')
  searchEvents () {
    this.$refs.container.scroll({ top: 0 });
    return {
      event_type: this.selectedEvents.map((t: Types.CheckboxElement) => t.id),
      sport: this.value,
      label: this.selectedLabels?.map((s: any) => s.id ? s.id : s),
      since: this.selectPastEvents && !this.selectedRange?.startDate
        ? this.$dayjs().format('YYYY-MM-DD')
        : this.selectedRange?.startDate ? this.$dayjs(this.selectedRange?.startDate).format('YYYY-MM-DD') : null,
      until: this.selectPastEvents && !this.selectedRange?.endDate ? null : this.selectedRange?.endDate ? this.$dayjs(this.selectedRange?.endDate).format('YYYY-MM-DD') : null,
    };
  }

  @Watch('mobileLocalisationFiltersModal')
  handleModalDisplay (val: string) {
    if (val === Modal.MOBILE_EVENTS) this.modal = Modal.MOBILE_EVENTS;
  }

  @Watch('destinationEventsFilters')
  populate () {
    if (!this.cantDoMore) {
      if (this.destinationEventsFilters.sport) {
        this.destinationEventsFilters.sport.map((s: string | number) => {
          const newValue = [...this.value];
          newValue.push(s);

          this.$emit('input', newValue);
        });
        this.$emit('input', [...new Set(this.value)]);
      }

      if (this.destinationEventsFilters.event_type) {
        this.destinationEventsFilters.event_type.map((t: string) => {
          this.eventTypes.map((e: Types.CheckboxElement) => {
            if (t === e.id) {
              e.checked = true;
              this.selectedEvents.push(e);
            }
          });
        });
      }

      if (this.destinationEventsFilters.since && !this.destinationEventsFilters.until) {
        this.selectPastEvents = true;
      } else {
        this.selectedRange = {
          startDate: this.destinationEventsFilters.since,
          endDate: this.destinationEventsFilters.until,
        };
      }
    }
    this.cantDoMore = true;
  }

  get dateRangeOpening () {
    if (process.client) {
      if (window.innerWidth > 768) return 'right';
      if (window.innerWidth <= 768 && window.innerWidth > 375) return 'center';
      return 'left';
    }
    return 'left';
  }

  get selectedRangeIsEmpty () {
    return objectIsEmpty(this.selectedRange);
  }

  mounted () {
    this.handleHeight();

    window.addEventListener('resize', this.handleHeight);

    this.$nuxt.$on('reset-queries', this.resetFilters);

    if (this.destinationEventsFilters.label) {
      this.selectedLabels = this.destinationEventsFilters.label;
    }

    this.populate();
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.handleHeight);
  }

  handleModalClose () {
    this.modal = '';
    this.$store.commit('explorer/SET_MOBILE_LOCALISATION_FILTERS_MODAL', '');
  }

  /* eslint array-callback-return: 0 */
  populateFilterArray (data: any) {
    const self: any = this;
    const vueData: any = self[data.data];
    const isDuplicated: any = vueData.filter((item: any) => item.id === data.element.id).length === 1;
    if (!isDuplicated) {
      vueData.push(data.element);
    } else {
      vueData.map((filter: any, index: number) => {
        if (filter.id === data.element.id) {
          vueData.splice(index, 1);
        }
      });
    }
    return vueData.slice(0);
  }

  handleHeight () {
    this.calculatedDivHeight = this.$refs.eventTab.clientHeight + (this.$route.path.includes('/explorer/destinations/') ? 128 : 198);
  }

  resetFilters () {
    /* eslint no-return-assign: 0 */
    const newSelectedSportsIds: (String | Number)[] = [];
    this.handleInput(newSelectedSportsIds);
    this.eventTypes.forEach((d: Types.CheckboxElement) => d.checked = false);
    this.selectedEvents = [];
    this.selectedLabels = [];
    this.selectedRange = {};
    this.value = [];
    this.selectPastEvents = false;
    this.$root.$emit('reset-date-range');
    this.$root.$emit('reset-checkboxes');
  }

  @Watch('value')
  watch () {
    this.$emit('input', this.value);
  }
}
